__turbopack_context__.v({
  "bullet": "_21docW_bullet",
  "bullet--active": "_21docW_bullet--active",
  "carousel": "_21docW_carousel",
  "carousel--extra-large-desktop": "_21docW_carousel--extra-large-desktop",
  "carousel--placeholder": "_21docW_carousel--placeholder",
  "shimmer": "_21docW_shimmer",
  "text-bar-sweep": "_21docW_text-bar-sweep",
});
